/**
 * PDP display for shoe sizes stored as a single string, e.g. "EU 37 (US 6)" → "No. 37=6".
 * Does not change cart/API keys — use only for visible labels.
 */
export function formatEuUsShoeSizeForDisplay(label) {
  const s = String(label ?? '').trim();
  if (!s) return s;
  const m = s.match(/^\s*EU\s+(\d+(?:\.\d+)?)\s*\(\s*US\s+(\d+(?:\.\d+)?)\s*\)\s*$/i);
  if (!m) return s;
  return `No. ${m[1]}=${m[2]}`;
}
